import { useApolloClient } from '@apollo/client';
import { Link } from '@ets-global/b2c-website-ui';
import { string } from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { QUOTE } from '../../../graphql/queries/purchase';
import { downloadFromUrl } from '../../../helpers/fileDownloader';

const DownloadQuoteLink = ({ registrationId, lang }) => {
  const apolloClient = useApolloClient();
  const { t } = useTranslation();

  return (
    <Link
      className="basket__quote"
      icon={'print'}
      aria-label={t('session-summary.purchase.print_quote')}
      onFocus={() => {}}
      onMouseOver={() => {
        apolloClient.query({
          query: QUOTE,
          variables: {
            registrationId,
            lang,
          },
        });
      }}
      onClick={() => {
        apolloClient
          .query({
            query: QUOTE,
            variables: {
              registrationId,
              lang,
            },
            fetchPolicy: 'network-only',
          })
          .then(({ data: { quote } }) => {
            if (!!quote) {
              downloadFromUrl(quote, `quote_${registrationId}_${lang}.pdf`);
            }
          });
      }}
    >
      <Trans>session-summary.purchase.print_quote</Trans>
    </Link>
  );
};

DownloadQuoteLink.propTypes = {
  registrationId: string.isRequired,
  lang: string.isRequired,
};

export default DownloadQuoteLink;
